<template>
    <div class="gifts-container">
        <div class="form-ct">
            <div class="form">
                <van-form ref="form" @submit="onSubmit">
                    <div class="package-list">
                        <van-swipe ref="swipe" style="width: 100%;" :loop="false" v-model="selectedPackage"
                            @change="onPackageChange">
                            <van-swipe-item v-for="(item, index) in packages" :key="index" :name="item.id"
                                class="package-item">
                                <div class="package-content">
                                    <div class="package-header">
                                        <div style="font-size: 16px;font-weight: bold;margin-bottom: 6px;color: white;">
                                            {{ item.name }}</div>
                                        <img :src="item.image" :alt="item.name" class="package-image">
                                    </div>
                                    <div class="package-info">
                                        <!-- 套餐详情表格 -->
                                        <div class="package-table">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>序号</th>
                                                        <th>品牌</th>
                                                        <th>产品名称</th>
                                                        <th>规格详情</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(subItem, idx) in item.items" :key="idx">
                                                        <td style="text-align: center;width: 30px;">
                                                            {{ idx + 1 }}</td>
                                                        <td style="font-weight: bold;width: 50px;">{{
                                                            subItem.brand }}</td>
                                                        <td style="font-size: 11px;">{{ subItem.name }}</td>
                                                        <td style="font-size: 11px;">{{ subItem.spec }}（{{
                                                            subItem.quantity }}）</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="package-desc">{{ item.name }}{{ item.description }}</div>

                                </div>
                            </van-swipe-item>
                        </van-swipe>

                        <!-- 套餐缩量图列表 -->
                        <div class="package-thumbnails">
                            <div v-for="(item, index) in packages" :key="index" class="package-thumbnail-item"
                                :class="{ 'active': selectedPackage === index }" @click="selectPackage(index)">
                                <div class="package-thumbnail-name">{{ item.name }}</div>
                            </div>
                        </div>
                    </div>

                    <!-- 收件人信息 -->
                    <div style="color: white;padding-left: 16px;margin: 20px 0 10px;">请填写收件人信息</div>
                    <van-field v-model="selectedTeamObj.text" name="team" label="班组" placeholder="请选择班组"
                        :rules="[{ required: true, message: '请选择班组' }]" @click="showTeamPicker = true" readonly>
                        <template #right-icon>
                            <van-icon name="arrow-down" size="16" />
                        </template>
                    </van-field>
                    <van-popup :lazy-render="false" v-model:show="showTeamPicker" round position="bottom">
                        <van-picker title="选择班组" :columns="teams" :columns-field-names="{ value: 'id' }"
                            @confirm="onTeamConfirm" @cancel="showTeamPicker = false" />
                    </van-popup>
                    <van-field v-model="recipient.recipient" name="recipient" label="收件人" placeholder="请输入收件人姓名"
                        :rules="[{ required: true, message: '请输入收件人姓名' }]" />
                    <van-field v-model="recipient.mobile" name="mobile" label="联系电话" placeholder="请输入联系电话"
                        :rules="[{ required: true, message: '请输入联系电话' }]" />
                    <van-field v-model="recipient.address" name="address" label="地址" placeholder="请输入详细地址"
                        :rules="[{ required: true, message: '请输入详细地址' }]" />

                    <!-- 配送日期选择 -->
                    <van-field v-model="sendDate" name="sendDate" label="配送日期" placeholder="请选择配送日期"
                        :rules="[{ required: true, message: '请选择配送日期' }]" @click="showDatePicker = true" readonly>
                        <template #right-icon>
                            <van-icon name="calendar" size="16" />
                        </template>
                    </van-field>

                    <!-- 日期选择器 -->
                    <van-popup v-model:show="showDatePicker" round position="bottom">
                        <van-date-picker :value="currentDate" type="date" title="选择配送日期" :min-date="minDate"
                            :max-date="maxDate" @confirm="onDateConfirm" @cancel="showDatePicker = false" />
                    </van-popup>

                    <div style="margin: 16px;">
                        <van-button round block style="background: rgb(255, 220, 46);border: none;font-weight: bold;"
                            native-type="submit">提交订单</van-button>
                    </div>
                </van-form>
            </div>
        </div>
    </div>
</template>
<script>
import Api from '@/Utils';
import { showFailToast, showSuccessToast, showDialog, showLoadingToast, closeToast, Icon, Popup, DatePicker, Swipe, SwipeItem, Field, Picker } from 'vant';

export default {
    name: 'GiftsPage',
    props: {
        msg: String
    },
    components: {
        VanIcon: Icon,
        VanPopup: Popup,
        VanDatePicker: DatePicker,
        VanSwipe: Swipe,
        VanSwipeItem: SwipeItem,
        VanField: Field,
        VanPicker: Picker
    },
    data() {
        return {
            selectedPackage: 0,
            selectedPackageObj: {},
            packages: [
                {
                    id: 'A',
                    name: '套餐A',
                    description: '产品明细',
                    image: require('@/assets/img/gift/a.png'),
                    items: [
                        { brand: '让茶', name: '让茶无糖竹香乌龙茶饮料500mI*15瓶', spec: '500ml*15', quantity: 1 },
                        { brand: '元气森林', name: '元气森林 0糖0脂0卡气泡水白桃味480mL*15瓶碳酸无糖', spec: '480mL*15瓶', quantity: 1 },
                        { brand: '米多奇', name: '米多奇能量馍片31g/（混合7口味)-26包-能量馍片800g', spec: '800g', quantity: 1 },
                        { brand: '富崎乐', name: '富崎乐/Modik\'s 祥瑞礼1120g', spec: '1120g', quantity: 1 },
                        { brand: '江中猴姑', name: '江中猴姑 彩虹饼干礼盒720g', spec: '720g', quantity: 1 },
                        { brand: '良品铺子', name: '良品铺子如沐春风零食礼盒1021g', spec: '1021g', quantity: 1 },
                        { brand: '甘源', name: '甘源 团圆好味礼坚果礼盒927g', spec: '927g', quantity: 1 },
                        { brand: '无穷', name: '无穷烤鸡小腿400g休闲小零食 香辣味', spec: '香辣味400g/盒', quantity: 2 }
                    ]
                },
                {
                    id: 'B',
                    name: '套餐B',
                    description: '产品明细',
                    image: require('@/assets/img/gift/b.png'),
                    items: [
                        { brand: '圣牧', name: '圣牧有机纯牛奶125ml*20盒 自然慢养沙漠mini奶', spec: '125ml*20盒', quantity: 1 },
                        { brand: '喜茶', name: '喜茶轻果茶蜜桃蔓越莓450ml*15瓶底糖低卡0脂', spec: '450ml*15瓶', quantity: 1 },
                        { brand: '广州酒家', name: '广州酒家黑金芝士190g+岩烧芝士190g薄脆饼干', spec: '黑金芝士190g+岩烧芝士190g薄脆饼干/盒', quantity: 1 },
                        { brand: '卡尔顿', name: '卡尔顿港式鸡蛋仔蛋糕500g/箱', spec: '500g/盒', quantity: 1 },
                        { brand: '甘源', name: '甘源 每日水果干礼盒780g', spec: '780g', quantity: 1 },
                        { brand: '洽洽', name: '洽洽 锦礼1160g+240mL', spec: '240ml+1160g', quantity: 1 },
                        { brand: '张飞', name: '张飞有礼 牛肉零食礼盒1049g', spec: '1049g', quantity: 1 },
                        { brand: '鲜记', name: '鲜记 鱼皮花生(dba)258g', spec: '258g', quantity: 1 },
                        { brand: '富崎乐', name: '富崎乐 臻礼肉肉礼盒1130g', spec: '1130g*1盒', quantity: 1 }
                    ]
                },
                {
                    id: 'C',
                    name: '套餐C',
                    description: '产品明细',
                    image: require('@/assets/img/gift/c.png'),
                    items: [
                        { brand: '娃哈哈', name: '娃哈哈 营养快线含乳饮料500ml*15瓶', spec: '500ml*15瓶', quantity: 1 },
                        { brand: '圣牧', name: '圣牧有机纯牛奶125ml*20盒 自然慢养沙漠mini奶', spec: '125ml*20盒', quantity: 1 },
                        { brand: '米多奇', name: '米多奇能量馍片31g/（混合7口味)-26包-能量馍片800g', spec: '800g', quantity: 1 },
                        { brand: '甘源', name: '甘源如意好味礼坚果礼盒1082g', spec: '1082g', quantity: 1 },
                        { brand: '无穷', name: '无穷零食大礼包 乐动缤纷礼盒 928g', spec: '928g', quantity: 1 },
                        { brand: '周黑鸭', name: '周黑鸭奋斗鸭礼盒553g（配手套）', spec: '553g', quantity: 1 },
                        { brand: '富崎乐', name: '富崎乐/odik\'s臻礼福至礼盒1220g', spec: '1220g*1盒', quantity: 1 },
                        { brand: '法丽兹', name: '法丽兹甜享曲奇691g礼盒装', spec: '691g', quantity: 1 }
                    ]
                },
                {
                    id: 'D',
                    name: '套餐D',
                    description: '产品明细',
                    image: require('@/assets/img/gift/d.png'),
                    items: [
                        { brand: '喜茶', name: '喜茶轻果茶蜜桃蔓越莓450ml*15瓶底糖低卡0脂', spec: '450ml*15瓶', quantity: 1 },
                        { brand: '元气森林', name: '元气森林 0糖0脂0卡气泡水白桃味480mL*15瓶碳酸无糖', spec: '480mL*15瓶', quantity: 1 },
                        { brand: '张飞', name: '张飞有礼 牛肉零食礼盒1049g', spec: '1049g', quantity: 1 },
                        { brand: '牧惠美', name: '牧惠美甄选超值礼盒724克', spec: '724g*1袋', quantity: 1 },
                        { brand: '富崎乐', name: '富崎乐 臻礼肉肉礼盒1130g', spec: '1120g*1盒', quantity: 1 },
                        { brand: '姚生记', name: '姚生记 琥珀大核桃仁138g*3罐【3口味组合】', spec: '海苔味138g+蜂蜜味138g+椰蓉味138g罐', quantity: 1 },
                        { brand: '精武', name: '精武全荤团圆鸭肉礼盒1036g/盒', spec: '1036g/盒', quantity: 1 },
                        { brand: '阿玛熊', name: '阿玛熊曲奇蛋卷 2盒礼包1738g', spec: '1738g', quantity: 1 }
                    ]
                }
            ],
            recipient: {
                recipient: '',
                mobile: '',
                address: ''
            },
            teams: [],
            selectedTeamObj: {},
            showTeamPicker: false,
            sendDate: '',
            currentDate: new Date(),
            showDatePicker: false,
            minDate: new Date(2026, 7, 1), // 2026-8-1 (月份从0开始)
            maxDate: new Date(2026, 9, 1)  // 2026-10-1
        };
    },
    methods: {
        onPackageChange(index) {
            this.selectedPackage = index;
            this.selectedPackageObj = this.packages[index];
        },
        selectPackage(index) {
            this.selectedPackage = index;
            this.selectedPackageObj = this.packages[index];
            // 手动控制swiper切换
            if (this.$refs.swipe) {
                this.$refs.swipe.swipeTo(index);
            }
        },
        onDateConfirm(date) {
            const vals = date.selectedValues
            this.sendDate = `${vals[0]}-${vals[1]}-${vals[2]}`;
            this.showDatePicker = false;
        },
        onTeamConfirm(data) {
            this.selectedTeamObj = data.selectedOptions[0]
            this.showTeamPicker = false;
        },

        onSubmit() {

            // 显示确认弹窗
            showDialog({
                title: '确认提交',
                message: `当前选择 ${this.selectedPackageObj.id} 套餐，是否提交订单？`,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                // 确认后执行提交
                this.doSubmitOrder();
            }).catch(() => {
                // 取消操作
                console.log('用户取消了提交');
            });
        },

        async doSubmitOrder() {
            // 验证表单
            this.$refs.form.validate().then(async () => {
                // 存储订单信息到localStorage
                showLoadingToast('提交中...');
                const orderInfo = {
                    ...this.recipient,
                    class: this.selectedTeamObj.class,
                    package: this.selectedPackageObj.name,
                    sendDate: this.sendDate
                };
                const response = await Api.post('/api/order/create', orderInfo);
                let resp = await response.json();
                closeToast();
                if (resp.code === 20000) {
                    localStorage.setItem('orderInfo', JSON.stringify({ ...orderInfo, packageObj: this.selectedPackageObj }));

                    // 显示成功提示
                    showSuccessToast('订单提交成功');

                    // 清空表单数据
                    this.recipient = {
                        recipient: '',
                        mobile: '',
                        address: ''
                    };
                    this.selectedTeamObj = {};
                    // 跳转到成功页面
                    setTimeout(() => {
                        this.$router.push('/success');
                    }, 1200);
                } else {
                    showFailToast(resp.message);
                }
            }).catch((err) => {
                console.log('err', err);

            })
        },
        async getClasses() {
            const response = await Api.get('/api/staff/classes');
            let resp = await response.json();
            if (resp.code === 20000) {
                this.teams = resp.data.map(item => ({
                    id: item.id,
                    text: item.status ? `${item.class}（已下单）` : item.class,
                    class: item.class,
                    disabled: item.status
                }));
            }
        }
    },
    mounted() {
        document.title = '套餐选择';
        this.selectedPackageObj = this.packages[0];
        this.getClasses();
    }
}
</script>

<style scoped>
.gifts-container {
    text-align: left;
    min-height: 100vh;
    padding: 0;
}

.form-ct {
    /* padding: 14px 0; */
    background-color: #0ba5a5e8;
    min-height: 100vh;
}

.form {
    /* padding: 14px; */
    box-sizing: border-box;
    padding: 5px;
    /* 棕色系半透明背景 */
}

.package-list {
    margin-bottom: 10px;
    box-sizing: border-box;
    width: 100%;

}

.package-item {
    margin-bottom: 15px;
    border-radius: 8px;
    overflow: hidden;

}

.package-item-active {
    background-color: rgba(200, 200, 200, 0.2);
}

.package-content {
    padding: 5px 5px 10px 5px;
}

.package-header {
    text-align: center;
    margin-bottom: 15px;
}

.package-image {
    width: 84%;
    height: auto;
    object-fit: cover;
    border-radius: 8px;
    margin: 0 auto 15px auto;
    display: block;
    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); */
    /* transition: transform 0.3s ease; */
    background-color: rgba(255, 255, 255, 0.4);
}

.package-item:hover .package-image {
    transform: scale(1.02);
}

.package-desc {
    color: rgba(255, 255, 255, 0.9);
    font-size: 13px;
    text-align: center;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
    margin-top: 5px;
}

.van-cell {
    background: transparent;
    font-size: 14px;
}

/deep/ .van-field__body input {
    color: white !important;
}

/deep/ .van-field__label {
    color: white !important;
    font-weight: 600;
}

/deep/ .van-field__control::-webkit-input-placeholder {
    color: #ffffffd0 !important;
}

/deep/ .van-radio__label {
    width: 100%;
}

/deep/ .van-radio__input {
    display: none;
}





/deep/ .van-radio__icon {
    display: none;
}

/deep/ .van-radio__icon--checked {
    display: none;
}

.package-table {
    margin-top: 10px;
    overflow-x: auto;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.6);
}

.package-table table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
}

.package-table th,
.package-table td {
    padding: 5px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.5);
    color: rgba(255, 255, 255, 0.9);
}

.package-table th {
    background-color: rgba(255, 255, 255, 0.1);
    font-weight: 600;
    text-align: center;
}

.package-thumbnails {
    display: flex;
    overflow-x: auto;
    padding: 10px 10px;
    margin-bottom: 20px;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.5) transparent;
}

.package-thumbnails::-webkit-scrollbar {
    height: 4px;
}

.package-thumbnails::-webkit-scrollbar-track {
    background: transparent;
}

.package-thumbnails::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 2px;
}

.package-thumbnail-item {
    flex: 0 0 auto;
    padding: 8px 12px;
    margin-right: 10px;
    cursor: pointer;
    border-radius: 20px;
    background-color: rgba(255, 255, 255, 0.2);
}

.package-thumbnail-item.active {
    background-color: white;
    color: #fe9b10;
    font-weight: bold;
}

.package-thumbnail-name {
    font-size: 12px;
    color: white;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.package-thumbnail-item.active .package-thumbnail-name {
    color: #fe9b10;
}
</style>